export default {"src":"/_next/static/media/section9-icon3.c9e1429c.svg","height":90,"width":91,"blurWidth":0,"blurHeight":0};